module.exports = __webpack_public_path__ + "img/Mark.4977720c.jpg";